import axios from 'axios';

const getReminders = () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/reminder`)
    .then(res => res)
    .catch(err => err);
};

export default getReminders;
